module.exports = __webpack_public_path__ + "img/bot-img.6f4a1af1.png";